import axiosInstance from "../api/axios";

/**
 * Zumale-admin Reports (ZUMALE_USER) — Revenue + Installments.
 * Array params (streams/types) are serialized as repeated keys (streams=A&streams=B)
 * so FastAPI's List[...] query parsing accepts them.
 */
const repeatArrays = { indexes: null };

export const getAdminRevenueReport = async ({ startDate, endDate, streams }) => {
  const params = { startDate, endDate };
  if (streams && streams.length) params.streams = streams;
  return axiosInstance.get("/admin/reports/revenue", { params, paramsSerializer: repeatArrays });
};

export const getAdminInstallmentsReport = async ({ startDate, endDate, types, status, page = 1, pageSize = 25 }) => {
  const params = { startDate, endDate, page, pageSize };
  if (types && types.length) params.types = types;
  if (status) params.status = status;
  return axiosInstance.get("/admin/reports/installments", { params, paramsSerializer: repeatArrays });
};
